import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { CWTypeScript } from "../../shared/utilty/js-actions/CWTypeScript";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { PTSMasterScreen_ScreenContext } from "../ptsmasterscreen/ptsmasterscreen-context";

declare let window: any;

export interface IBildirimListesi_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IBildirimListesi_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetUserByUsername: any[];
  GetUserByUsername_dummy: any[];
  BildirimleriGetir: any[];
  BildirimleriGetir_dummy: any[];
  OkunmamisBildirimSayisiGetir: any[];
  OkunmamisBildirimSayisiGetir_dummy: any[];
  SayiGuncelle: string;
  SayiGuncelle_dummy: string;
  isComp611858Visible: "visible" | "hidden";
  isComp644882Visible: "visible" | "hidden";
}

export class BildirimListesi_ScreenBase extends React.PureComponent<
  IBildirimListesi_ScreenProps,
  any
> {
  static contextType = PTSMasterScreen_ScreenContext;
  declare context: React.ContextType<typeof PTSMasterScreen_ScreenContext>;
  bildirimlistesi_876858_value_kuikaTableRef: React.RefObject<any>;
  bildirimlistesi_861093_value_kuikaTableRef: React.RefObject<any>;
  bildirimlistesi_277585_value_kuikaTableRef: React.RefObject<any>;
  bildirimlistesi_274723_value_kuikaTableRef: React.RefObject<any>;
  bildirimlistesi_914116_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "08e1cb20-24ad-e190-d46b-beded98dd4ae",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4106607f-9ae3-47ff-8d8a-3ced44ab92c6",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "7c5c3ed9-ed0e-4ea9-9448-1cb879cdec6f",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 258299, PropertyName: "value", Value: "Toplam Bildirim" },
        { Id: 942838, PropertyName: "value", Value: "Okunmamış" },
        { Id: 936864, PropertyName: "value", Value: "Onaylanan" },
        { Id: 706845, PropertyName: "value", Value: "Reddedilen" },
        { Id: 728186, PropertyName: "tab", Value: "Tümü" },
        { Id: 118875, PropertyName: "title", Value: "Title" },
        { Id: 532903, PropertyName: "value", Value: "[datafield:baslik]" },
        { Id: 556242, PropertyName: "value", Value: "[datafield:mesaj]" },
        { Id: 735816, PropertyName: "value", Value: "|" },
        { Id: 294355, PropertyName: "value", Value: "|" },
        { Id: 297572, PropertyName: "value", Value: "[datafield:projeadi]" },
        { Id: 394820, PropertyName: "value", Value: "→" },
        { Id: 736330, PropertyName: "value", Value: "08.05.2026 09:15" },
        { Id: 48514, PropertyName: "tab", Value: "Okunmamış" },
        { Id: 830332, PropertyName: "title", Value: "Title" },
        { Id: 997566, PropertyName: "value", Value: "[datafield:baslik]" },
        { Id: 791873, PropertyName: "value", Value: "[datafield:mesaj]" },
        { Id: 234551, PropertyName: "value", Value: "|" },
        { Id: 166299, PropertyName: "value", Value: "|" },
        { Id: 986428, PropertyName: "value", Value: "[datafield:projeadi]" },
        { Id: 559087, PropertyName: "value", Value: "→" },
        { Id: 130156, PropertyName: "value", Value: "08.05.2026 09:15" },
        { Id: 90266, PropertyName: "tab", Value: "Onaylanan" },
        { Id: 329569, PropertyName: "title", Value: "Title" },
        { Id: 775183, PropertyName: "value", Value: "[datafield:baslik]" },
        { Id: 42616, PropertyName: "value", Value: "[datafield:mesaj]" },
        { Id: 105973, PropertyName: "value", Value: "|" },
        { Id: 316650, PropertyName: "value", Value: "|" },
        { Id: 221591, PropertyName: "value", Value: "[datafield:projeadi]" },
        { Id: 617630, PropertyName: "value", Value: "→" },
        { Id: 9250, PropertyName: "value", Value: "08.05.2026 09:15" },
        { Id: 242860, PropertyName: "tab", Value: "Reddedilen" },
        { Id: 618556, PropertyName: "title", Value: "Title" },
        { Id: 615610, PropertyName: "value", Value: "[datafield:baslik]" },
        { Id: 714652, PropertyName: "value", Value: "[datafield:mesaj]" },
        { Id: 883632, PropertyName: "value", Value: "|" },
        { Id: 569559, PropertyName: "value", Value: "|" },
        { Id: 589776, PropertyName: "value", Value: "[datafield:projeadi]" },
        { Id: 356325, PropertyName: "value", Value: "→" },
        { Id: 626574, PropertyName: "value", Value: "08.05.2026 09:15" },
        { Id: 22328, PropertyName: "tab", Value: "Bekliyor" },
        { Id: 629896, PropertyName: "title", Value: "Title" },
        { Id: 683821, PropertyName: "value", Value: "[datafield:baslik]" },
        { Id: 167290, PropertyName: "value", Value: "[datafield:mesaj]" },
        { Id: 174402, PropertyName: "value", Value: "|" },
        { Id: 921989, PropertyName: "value", Value: "|" },
        { Id: 433177, PropertyName: "value", Value: "[datafield:projeadi]" },
        { Id: 949714, PropertyName: "value", Value: "→" },
        { Id: 201169, PropertyName: "value", Value: "08.05.2026 09:15" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.bildirimlistesi_876858_value_kuikaTableRef = React.createRef();
    this.bildirimlistesi_861093_value_kuikaTableRef = React.createRef();
    this.bildirimlistesi_277585_value_kuikaTableRef = React.createRef();
    this.bildirimlistesi_274723_value_kuikaTableRef = React.createRef();
    this.bildirimlistesi_914116_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetUserByUsername: [],
      BildirimleriGetir: [],
      OkunmamisBildirimSayisiGetir: [],
      SayiGuncelle: "",
      isComp611858Visible: "hidden",
      isComp644882Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "bildirimlistesi",
        "ptsmasterscreen_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.BildirimListesiPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "bildirimlistesi",
      "ptsmasterscreen_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "bildirimlistesi",
      "ptsmasterscreen_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.BildirimListesiPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  BildirimListesiPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      AliciUserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      AliciRolAdi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].roller
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].roller
            : null
        ),
        "string"
      ),
      BildirimDurumu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("TUMU", "string"),
        "string"
      ),
      AliciUserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      AliciRolAdi_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].roller
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].roller
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BildirimListesi/BildirimListesiPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserByUsername = result?.data.getUserByUsername;
    stateVars.BildirimleriGetir = result?.data.bildirimleriGetir;

    stateVars.OkunmamisBildirimSayisiGetir =
      result?.data.okunmamisBildirimSayisiGetir;
    formVars.bildirimlistesi_844118_value = ReactSystemFunctions.toString(
      this,
      stateVars.OkunmamisBildirimSayisiGetir !== undefined
        ? stateVars.OkunmamisBildirimSayisiGetir?.length > 0
          ? stateVars.OkunmamisBildirimSayisiGetir[0].sayi
          : null
        : this.state.OkunmamisBildirimSayisiGetir?.length > 0
        ? this.state.OkunmamisBildirimSayisiGetir[0].sayi
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BildirimListesiPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BildirimListesiPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SayiGuncelle = CWTypeScript.SayiGuncelle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.OkunmamisBildirimSayisiGetir !== undefined
          ? stateVars.OkunmamisBildirimSayisiGetir?.length > 0
            ? stateVars.OkunmamisBildirimSayisiGetir[0].sayi
            : null
          : this.state.OkunmamisBildirimSayisiGetir?.length > 0
          ? this.state.OkunmamisBildirimSayisiGetir[0].sayi
          : null
      )
    );
    formVars.bildirimlistesi_844118_value = ReactSystemFunctions.toString(
      this,
      stateVars.OkunmamisBildirimSayisiGetir !== undefined
        ? stateVars.OkunmamisBildirimSayisiGetir?.length > 0
          ? stateVars.OkunmamisBildirimSayisiGetir[0].sayi
          : null
        : this.state.OkunmamisBildirimSayisiGetir?.length > 0
        ? this.state.OkunmamisBildirimSayisiGetir[0].sayi
        : null
    );

    stateVars.dataSource_876858 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;
    stateVars.isComp611858Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "bildirimlistesi_876858_value",
          "okundu"
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp644882Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "bildirimlistesi_876858_value",
          "okundu"
        ),
        false
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_861093 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_277585 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_274723 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_914116 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  BildirimListesiComponent_560805_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      AliciUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      AliciRolAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].roller
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].roller
            : null
        ),
        "string"
      ),
      BildirimDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BildirimListesi/BildirimListesiComponent_560805_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BildirimleriGetir = result?.data.bildirimleriGetir;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.BildirimListesiComponent_560805_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BildirimListesiComponent_560805_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_876858 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_861093 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_277585 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_274723 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_914116 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BildirimListesiComponent_728186_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      AliciUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      AliciRolAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].roller
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].roller
            : null
        ),
        "string"
      ),
      BildirimDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("TUMU", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BildirimListesi/BildirimListesiComponent_728186_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BildirimleriGetir = result?.data.bildirimleriGetir;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.BildirimListesiComponent_728186_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BildirimListesiComponent_728186_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_876858 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_861093 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_277585 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_274723 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_914116 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BildirimListesiComponent_48514_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      AliciUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      AliciRolAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].roller
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].roller
            : null
        ),
        "string"
      ),
      BildirimDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("OKUNMAMIS", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BildirimListesi/BildirimListesiComponent_48514_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BildirimleriGetir = result?.data.bildirimleriGetir;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.BildirimListesiComponent_48514_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BildirimListesiComponent_48514_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_876858 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_861093 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_277585 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_274723 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_914116 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BildirimListesiComponent_90266_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      AliciUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      AliciRolAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].roller
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].roller
            : null
        ),
        "string"
      ),
      BildirimDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BildirimListesi/BildirimListesiComponent_90266_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BildirimleriGetir = result?.data.bildirimleriGetir;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.BildirimListesiComponent_90266_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BildirimListesiComponent_90266_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_876858 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_861093 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_277585 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_274723 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_914116 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BildirimListesiComponent_242860_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      AliciUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      AliciRolAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].roller
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].roller
            : null
        ),
        "string"
      ),
      BildirimDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("REDDEDILDI", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BildirimListesi/BildirimListesiComponent_242860_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BildirimleriGetir = result?.data.bildirimleriGetir;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.BildirimListesiComponent_242860_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BildirimListesiComponent_242860_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_876858 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_861093 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_277585 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_274723 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_914116 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BildirimListesiComponent_22328_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      AliciUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      AliciRolAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].roller
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].roller
            : null
        ),
        "string"
      ),
      BildirimDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("BEKLIYOR", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BildirimListesi/BildirimListesiComponent_22328_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BildirimleriGetir = result?.data.bildirimleriGetir;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.BildirimListesiComponent_22328_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BildirimListesiComponent_22328_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_876858 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_861093 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_277585 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_274723 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    stateVars.dataSource_914116 =
      stateVars.BildirimleriGetir ?? this.state.BildirimleriGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.BildirimListesiPageInit();
    }
  }
}
